// extracted by mini-css-extract-plugin
export var dropdown = "_iq-0";
export var imagePlaceholder = "_iq-2";
export var imageWrapper = "_iq-3";
export var productImage = "_iq-1";
export var truncateContainer = "_iq-4";
export var truncateText = "_iq-5";